export default __webpack_public_path__ + "static/media/logohorizontal.0b9bc539.png";